import getLocalString from "constants/Localization";
import { useGetReportCompanyOrClientDetailsMutation } from "generated/graphql";

import useBitumioMutation from "hooks/useBitumioMutation";

const useGetReportCompanyOrClientDetails = (showSuccessMessage: boolean = false) => {
  const [mutation, { loading, data, error }] = useGetReportCompanyOrClientDetailsMutation();
  const [getReportCompanyOrClientDetails, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "getReportCompanyOrClientDetails",
    },
    showSuccessMessage
      ? {
          successMessage: getLocalString("organization.generate-report-success"),
          failureMessage: getLocalString("organization.generate-report-failure"),
        }
      : {
          hideMessage: true,
        }
  );

  return [getReportCompanyOrClientDetails, { ...context, data }] as const;
};

export default useGetReportCompanyOrClientDetails;
